<div class="opening-settings">
  <div class="mode-selector">
    <label>
      <input type="radio" name="modeLocal" [checked]="modeLocal === 'open'" (click)="onModeClick($event, 'open')" />🟢 {{ 'calendar.mode.open' | translate }}
    </label>
    <label>
      <input type="radio" name="modeLocal" [checked]="modeLocal === 'closed'" (click)="onModeClick($event, 'closed')" />🔴 {{ 'calendar.mode.closed' | translate }}
    </label>
  </div>
  <div *ngIf="modeLocal === 'open'" class="weekdays">
    <h4>{{ 'calendar.regular_opening_days' | translate }}</h4>
    <div class="days">
      <button *ngFor="let d of daysOfWeek" class="day" [class.selected]="openingDays.includes(d.id)" (click)="toggleWeekDay(d.id)" > {{ ('calendar.weekday.' + d.key) | translate }} </button>
    </div>
  </div>
  <div class="hours-section">
    <h4>{{ 'calendar.to' | translate }}</h4>
    <div *ngFor="let range of openingHours; let i = index" class="hour-row">
      <span>De</span>
      <input type="number" min="0" max="23" [value]="range.from" (change)="updateHourRange(i, 'from', $event.target.value)" />
      <span>à</span>
      <input type="number" min="0" max="23" [value]="range.to" (change)="updateHourRange(i, 'to', $event.target.value)" />
      <select [(ngModel)]="range.day" (ngModelChange)="updateHourRange(i, 'day', $event)" [disabled]="i === 0">
          <option [ngValue]="undefined">--</option>
          <option *ngFor="let d of daysOfWeek" [ngValue]="d.id"> {{ ('calendar.weekday.' + d.key) | translate }}</option>
      </select>
      <button type="button" class="btn-remove" *ngIf="i !== 0" (click)="removeHourRange(i)">❌</button>
    </div>
    <button type="button" class="btn-add" (click)="addHourRange()"> {{ 'calendar.add_range' | translate }}</button>
  </div>
  <h4 *ngIf="modeLocal === 'open'" class="calendar-subtitle"> {{ 'calendar.exceptional_opening_days' | translate }} </h4>
  <div class="calendar">
    <div class="calendar-header">
      <button (click)="changeMonth(-1)">‹</button>
      <span>{{ formatMonth() | titlecase }}</span>
      <button (click)="changeMonth(1)">›</button>
    </div>
  <div class="calendar-grid">
  <div *ngFor="let d of daysOfWeek" class="weekday-label"> {{ ('calendar.weekday.' + d.key) | translate }}</div>
  <ng-container *ngFor="let cell of monthCells">
    <div *ngIf="!cell" class="calendar-day placeholder"></div>
    <button *ngIf="cell" class="calendar-day" [class.is-open]="isOpen(cell)" [class.is-closed]="!isOpen(cell)" (click)="toggleCalendarDay(cell)"> {{ cell | date:'d' }}</button>
  </ng-container>
</div>
</div>
</div>
